<!-- <div class="p-10 flex-col-container">
<div class="B font18" style="position:sticky;">Accounts:</div> -->
<div class="flex-row-container m-b5 m-t10" > 
  <span class="B flex-1 font20"></span>
  <button mat-stroked-button class="m-r10" [ngClass]="isDataChanged?'highlight-bg':''" color="primary" (click)="saveSelectedAccounts()">Save</button>
  <div class="flex-row-container">
    <button  mat-raised-button color="primary" [matMenuTriggerFor]="clientmenu">
      Add Hypothetical Account for
    </button>
    <mat-icon class="pointer m-lr10 m-t7" style="font-size: 20px;" matTooltip="Refresh" (click)=refresh()>refresh</mat-icon>  
  </div>
</div>
<mat-table *ngIf="dataSource" [dataSource]="dataSource"> 
    <!-- Checkbox Column -->
        <ng-container matColumnDef="select" sticky>
          <mat-header-cell *matHeaderCellDef style="width: 20px !important;">
            <mat-checkbox (change)="$event ? masterToggle() : null"
                          [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()"
                          [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell   *matCellDef="let row" >
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selectionToggle(row) : null"
                          [checked]="selection.isSelected(row)"
                          [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
            
        <ng-container matColumnDef="id" sticky>
          <mat-header-cell *matHeaderCellDef class="p-r10" > ACCOUNT </mat-header-cell>
          <mat-cell class="p-r10 text-truncate" *matCellDef="let element"> 
            <div *ngIf="element.custodianType!=='HypoEA'" class="flex-col-container p-tb5">
              <span [matTooltip]="element.CustodianType==='Internal' && element.gfoCustodyAccount?element.gfoCustodyAccount: (element.CustodianType==='Internal'?element.id:element.accountNickname)">
                {{(element.CustodianType==='Internal' && element.gfoCustodyAccount)?element.gfoCustodyAccount:
                (element.CustodianType==='Internal'?element.id : element.accountNickname)}}
              </span> 
              <span class="blueText15">
                {{element.CustodianType==='External'?element.CustodyAccount : 
                (element.CustodianType==='Internal' && element.gfoCustodyAccount && element.CustodyAccount?element.CustodyAccount:'')}} </span>
              <span class="blueText14">{{element.CustodianType==='External'?element.CustodianName : ''}} </span>
              <span class="blueText14">{{element.LegalEntityName}}</span>
              <span class="font14 gray-text text-truncate">{{element.registrationDesc}}</span>
            </div>
            <div *ngIf="element.custodianType==='HypoEA'" class="flex-col-container">
              <span  matTooltip="HYPOTHETICAL">
                {{element.accountNickname}}<sup class="p-1 font11 super">HYPOTHETICAL</sup>              
              </span>
              <span class="blueText14">{{element.LegalEntityName}}</span>
            </div>
          </mat-cell>                      
        </ng-container>
      
        <!-- <ng-container matColumnDef="legalEnityName">
            <mat-header-cell *matHeaderCellDef> Client Name (Person or Entity) </mat-header-cell>
            <mat-cell class="p-r10"  *matCellDef="let element"> {{element.LegalEntityName}} </mat-cell>
          </ng-container> -->
        
        <ng-container matColumnDef="taxstatus">
          <mat-header-cell *matHeaderCellDef> TAX STATUS </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.taxstatus  | uppercase}} </mat-cell>
        </ng-container>
      
        
        <ng-container matColumnDef="modelName">
          <mat-header-cell *matHeaderCellDef> ACCOUNT TYPE/PROGRAM/MODEL </mat-header-cell>
          <mat-cell class="p-r10 p-tb5" *matCellDef="let element"> 
            <div class="flex-col-container">
              <span>{{element.accounttype}}</span>
              <span *ngIf="element.accounttype && element.accounttype.toUpperCase()==='MANAGED'" class="blueText16">{{element.modelType}} </span>
              <span *ngIf="element.accounttype && element.accounttype.toUpperCase()==='MANAGED'" class="gray-text font16">{{element.modelName}} </span>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell class="th-right" *matHeaderCellDef >                    
          </mat-header-cell>
          <mat-cell class="th-right" *matCellDef="let element" >
            <mat-icon *ngIf="element.custodianType==='HypoEA'" class="font18 pointer" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Edit Hypothetical Account" (click)="editHypotheticalAccount(element.id, element.legalEnityId)">edit</mat-icon>              
            <sup *ngIf="element.custodianType==='HypoEA'" class="p-1 font11 superIcon"><mat-icon class="m-l5 font10">launch</mat-icon></sup>              
          </mat-cell>
        </ng-container>        
        <ng-container matColumnDef="AccountKPIs.AccountTotal">
          <mat-header-cell style="justify-content: flex-end" *matHeaderCellDef> MARKET VALUE </mat-header-cell>
          <mat-cell style="justify-content: flex-end"  *matCellDef="let element">{{element.AccountKPIs.AccountTotal | currency:'USD': 'symbol' : '1.0-0'}}</mat-cell>
          <!-- <span [ngStyle]="{'margin-top.px': (element.accounttype && element.accounttype.toUpperCase()==='MANAGED') ? -18 : ''}"></span> -->
        </ng-container>

              
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedColumns;" 
            (click)="selection.toggle(row)">
        </mat-row>
        <!-- <mat-row mat-row *matRowDef="let row; columns: displayedColumns;"             
            (click)="selection.toggle(row)">
        </mat-row> -->
</mat-table>
<mat-menu #clientmenu="matMenu">
  <div class="" *ngFor="let client of clientMenuItems">
    <button class="font14" mat-menu-item (click)="addHypotheticalAccount(client.clientid)"> {{client.displayClientname}}<mat-icon class="m-l5 m-t7 font16">launch</mat-icon></button>    
  </div> 
</mat-menu>

<!-- </div> -->